import { render, staticRenderFns } from "./UpdateTag.vue?vue&type=template&id=af49c310"
import script from "./UpdateTag.vue?vue&type=script&lang=js"
export * from "./UpdateTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports